import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOhFollowUp } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";
import { getHeaderActionType, getTerminalId } from "../helpers";

/**
 * POST API call for OH Followup
 * @returns - Save and submit Followup api and return same object
 */
export const OnHandFollowUpAPI = async (
  params: IOhFollowUp,
  osdNumber: number,
  action: string
) => {
  try {
    const url = `${getUrl(ApiType.ON_HAND_FOLLOWUP).replace(
      ":osdNumber",
      osdNumber.toString()
    )}/${action}`;
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.ON_HAND_FOLLOWUP) || {};
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Destination-Terminal": getTerminalId(),
      "OSD-Action-Type": getHeaderActionType(action),
      "OSD-Exception-Number": osdNumber?.toString(),
    };
    const response = await axios.post(url, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.ohFollowupError);
  }
};
